import { render, staticRenderFns } from "./modalElogios.vue?vue&type=template&id=7c5b3c23&scoped=true"
import script from "./modalElogios.vue?vue&type=script&lang=js"
export * from "./modalElogios.vue?vue&type=script&lang=js"
import style0 from "./modalElogios.vue?vue&type=style&index=0&id=7c5b3c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b3c23",
  null
  
)

export default component.exports